<template>
  <v-container>
    <v-row justify="center">
      <v-col :lg="4">
        <v-card>
          <v-card-title>
            <div>
              <h3 class="headline">{{ $t('Login') }}</h3>
            </div>
          </v-card-title>
          <form @submit.prevent="login">
            <v-card-text>
              <validation-observer ref="form">
                <validation-provider v-slot="{errors }" name="email" rules="required|email|max:255">
                  <v-text-field
                    name="email"
                    :label="$t('E-mail')"
                    id="email"
                    type="email"
                    v-model="email"
                    :error-messages="errors"
                    required
                  ></v-text-field>
                </validation-provider>
                <validation-provider v-slot="{errors}" name="password" rules="required|min:8">
                  <v-text-field
                    name="password"
                    :label="$t('Password')"
                    id="password"
                    :type="showPassword ? 'text' : 'password'"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="showPassword = !showPassword"
                    v-model="password"
                    :error-messages="errors"
                    required
                  ></v-text-field>
                </validation-provider>
                <v-checkbox :label="$t('Remember me')" v-model="remember"></v-checkbox>
              </validation-observer>
            </v-card-text>
            <v-card-actions>
              <v-btn
                text
                small
                color="grey"
                :to="{name: 'Password Reset'}"
              >{{ $t('Password forgotten') }}</v-btn>
              <v-spacer></v-spacer>
              <v-btn type="submit" data-cy="button-login-submit" :loading="loading" color="primary">{{ $t('Login') }}</v-btn>
            </v-card-actions>
          </form>
          <v-divider></v-divider>
          <v-row justify="center" class="my-4 pb-4">
            <v-btn outlined color="secondary" class="text-none" text @click="authProvider('graph')">
              <v-icon class="mr-2">$microsoft-azure</v-icon>
              {{ $t('auth.microsoft') }}
            </v-btn>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import snackbar from "@/mixins/snackbar";
import auth from "@/api/auth";
import { ValidationProvider, ValidationObserver } from "vee-validate";

export default {
  name: "Login",
  components: { ValidationObserver, ValidationProvider },
  mixins: [snackbar],
  data() {
    return {
      email: this.$route.query.email ?? "",
      password: "",
      remember: false,
      loading: false,
      error: false,
      showPassword: false,
    };
  },
  methods: {
    authProvider(provider) {
      this.loading = true;
      this.$auth
        .authenticate(provider)
        .then((response) => {
          auth.csrfCookie().then(() => {
            auth
              .socialLogin(provider, response)
              .then(this.getUserDataAndRedirect)
              .catch((error) => {
                if (
                  error.response &&
                  error.response.status === 422 &&
                  error.response.data.errors?.email
                ) {
                  this.snackbar("error", error.response.data.errors.email[0]);
                } else {
                  this.errorLogin();
                }
                this.loading = false;
              });
          });
        })
        .catch(() => {
          this.errorLogin();
          this.loading = false;
        });
    },
    login() {
      this.$refs.form.validate().then((success) => {
        if (!success) {
          return;
        }
        this.loading = true;
        const data = {
          email: this.email,
          password: this.password,
          remember: this.remember,
        };
        auth.csrfCookie().then(() => {
          auth
            .login(data)
            .then(this.getUserDataAndRedirect)
            .catch((error) => {
              if (error.response && error.response.status === 422) {
                let errors = error.response.data.errors;
                this.$refs.form.setErrors(errors);
              } else {
                this.errorLogin();
              }
              this.loading = false;
            });
        });
      });
    },
    getUserDataAndRedirect(response) {
      if (response.status === 204) {
        this.$store
          .dispatch("auth/fetchUser")
          .then(() => {
            const redirectPath = this.$router.currentRoute.query.redirect;
            if (redirectPath) {
              this.$router.push({ path: redirectPath });
            } else {
              this.$router.push({ name: "Home" });
            }
          })
          .catch(() => {
            this.$router.push({ name: "Login" });
            this.loading = false;
          });
      } else {
        this.errorLogin();
        this.loading = false;
      }
    },
    errorLogin() {
      this.snackbar(
        "error",
        this.$t("An error occured during login, please try again")
      );
    },
  },
};
</script>